<template>
  <div id="build-nav">
    <v-toolbar flat fixed>
      <v-btn icon @click="drawer = !drawer" class="hidden-md-and-up">
        <v-icon>menu</v-icon>
      </v-btn>
      <v-toolbar-title>
        <router-link to="/">
          <img @click="$emit('startOver')" class="builder-logo" src="../../static/images/Dealer-Draft_logo.png">
        </router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items class="build-controls" v-if="startBuild === true || screenNumber > 1">
        <v-btn v-if="isMobile768 && startBuild === true && screenNumber > 1 && previewScreen === false" @click="$emit('startOver')" flat><v-icon small>refresh</v-icon></v-btn>
        <v-btn v-else-if="startBuild === true && screenNumber > 1 && previewScreen === false" @click="$emit('startOver')" flat>Start Over</v-btn>
        <v-toolbar-items v-if="startBuild === true && previewScreen === false" class="directional-group">
          <v-btn v-if="isMobile768" @click="$emit('previous')" flat :disabled="prevDisabled" class="directional"><v-icon left small>arrow_back</v-icon></v-btn>
          <v-btn v-else @click="$emit('previous')" flat :disabled="prevDisabled" class="directional"><v-icon left small>arrow_back</v-icon>Previous</v-btn>
          <v-btn v-if="isMobile768" @click="$emit('next')" flat :disabled="nextDisabled" class="directional"><v-icon right small>arrow_forward</v-icon></v-btn>
          <v-btn v-else @click="$emit('next')" flat :disabled="nextDisabled" class="directional">Next<v-icon right small>arrow_forward</v-icon></v-btn>
        </v-toolbar-items>
        <v-btn v-if="previewScreen === true" dark icon large class="camera-btn" @click="shoot">
          <v-icon>photo_camera</v-icon>
        </v-btn>
        <v-btn v-if="previewScreen === true" dark icon large class="camera-btn" @click="$emit('openDialog')">
          <v-icon>link</v-icon>
        </v-btn>
        <v-toolbar-items v-if="startBuild === true && previewScreen === false">
          <v-btn v-if="isMobile768" @click="$emit('preview')" flat class="preview"><v-icon small>monitor</v-icon></v-btn>
          <v-btn v-else @click="$emit('preview')" flat outline class="preview">Preview</v-btn>
        </v-toolbar-items>
        <v-toolbar-items v-if="previewScreen === true">
          <v-btn @click="$emit('goback')" flat class="go-back">Go Back</v-btn>
        </v-toolbar-items>
      </v-toolbar-items>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down extra-padding">
        <router-link to="/">
          <v-btn @click="$emit('startOver')" flat>Home</v-btn>
        </router-link>
      </v-toolbar-items>
    </v-toolbar>
    <v-navigation-drawer v-model="drawer" fixed temporary>
      <v-list>
        <v-list-tile to="/builder">
          <v-list-tile-title>Home Build</v-list-tile-title>
        </v-list-tile>
        <v-list-tile to="/srp-builder">
          <v-list-tile-title>SRP Build</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import screenMixin from '../mixins/screenMixin';

export default {
  mixins: [screenMixin],
  props: ["startBuild", "screenNumber", "previewScreen", "currentRoute", "activeColumn"],
  
  data() {
    return {
      drawer: false,
    };
  },

  computed: {
    build() {
      return this.$route.path === "/builder";
    },
    prevDisabled() {
      return !(this.screenNumber === 3 || this.screenNumber === 4) || this.activeColumn === 2;
    },
    nextDisabled() {
      return !(this.screenNumber === 2 || this.screenNumber === 3) || this.activeColumn === 2;
    }
  },

  methods: {
    shoot() {
      this.$html2canvas(document.querySelector("#preview")).then((canvas) => {
        canvas.toBlob((blob) => {
          saveAs(blob, "homepage.png");
        });
      });
    }
  }
};
</script>

<style scoped>
  .builder-logo {
    max-height: 40px;
  }
  .v-toolbar--fixed {
    z-index: 10;
  }
  .build-controls {
    justify-content: space-between;
    min-width: 500px;
  }
  .camera-btn {
    background-color: #006aff;
  }
  #build-nav .preview {
    color: #006aff;
    font-weight: 600;
    height: auto;
    padding-top: 8px;
    padding-bottom: 8px;
  }
  #build-nav .go-back {
    font-weight: 400 !important;
  }
  #build-nav .preview, #build-nav .go-back {
    min-width: 93px;
  }
  #build-nav .directional {
    min-width: 124px;
  }
  .extra-padding {
    padding-left: 70px;
  }
  .mobile-nav {
    width: 250px;
  }

  @media (max-width: 959px) {
    .build-controls {
      justify-content: end;
    }
    .builder-logo {
      max-height: 30px;
    }
    .v-btn {
      font-size: 12px;
      padding: 0 12px;
    }
    .v-navigation-drawer--temporary, 
    .v-navigation-drawer--is-mobile {
      z-index: 99999999;
    }
  }
  @media (max-width: 767px) {
    .build-controls {
      min-width: auto;
    }
    .builder-logo {
      max-height: 20px;
    }
    .v-toolbar__title:not(:first-child) {
      margin-left: 0;
    }
    #build-nav .directional.v-btn {
      min-width: 60px;
    }
    #build-nav .directional.v-btn .v-icon--right {
      margin-left: 0;
    }
    #build-nav .directional.v-btn .v-icon--left {
      margin-right: 0;
    }
    #build-nav .preview {
      min-width: auto;
      color: inherit;
    }
    .v-btn {
      font-size: 10px;
      padding: 0 8px;
      min-width: auto;
    }
  }
  @media (max-width: 399px) {
    #build-nav .directional.v-btn {
      min-width: 20px;
    }
    .camera-btn.v-btn--large .v-icon {
      font-size: 12px;
    }

    .camera-btn.v-btn--large {
      width: 22px;
      height: 22px;
    }

    #build-nav .go-back {
      min-width: 40px;
    }
  }
</style>